import request from '@/utils/request'
import requestAd from '@/utils/requestAd'

// 添加会议室
export function addMeeting(query) {
  return request({
    url: '/room',
    method: 'post',
    data: query
  })
}

// 删除会议室
export function deleteMeeting(id) {
  return request({
    url: '/room/delete/' + id,
    method: 'get'
  })
}

// 查询会议室
export function searchMeeting(data) {
  return request({
    url: '/room/search',
    method: 'post',
    data: data
  })
}

// 编辑会议室
export function editMeeting(data) {
  return request({
    url: '/room/edit/' + data.id,
    method: 'post',
    data: data
  })
}
// 生成二維碼
export function getQrcode(params) {
  return requestAd({
    url: '/companySeat/generate/print',
    method: 'get',
    params
  })
}

